import { useEffect, useRef, useState } from 'react';

// A successful, unsearched, empty selling-product list is authoritative: no dealer
// can sell the product, so a retained selection is cleared even if its own check failed.
export const useClearDealerWhenNoneSell = (
    hasProduct: boolean,
    hasDealer: boolean,
    clearDealer: () => void,
) => {
    const [noDealerSells, setNoDealerSells] = useState(false);
    const clearDealerRef = useRef(clearDealer);
    clearDealerRef.current = clearDealer;

    const mustClear = hasProduct && hasDealer && noDealerSells;

    useEffect(() => {
        if (mustClear) {
            clearDealerRef.current();
        }
    }, [mustClear]);

    return setNoDealerSells;
};
